<div id="invoiceDetails" class="pr-2" [formGroup]="shipmentForm">
  <div>
    <div class="row" formGroupName="invoiceDetails">
      <div class="col-md-5 form-group">
        <label>{{ 'shipment.invoice.invoiceNumber' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="invoiceNumber" />
        <app-error-component
          [controlName]="
            shipmentForm.get('invoiceDetails').get('invoiceNumber')
          "></app-error-component>
      </div>
      <div class="col-md-5 form-group">
        <div class="row">
          <label>{{ 'shipment.invoice.invoiceDate' | translate }}: </label>
          <div style="display: inline-flex">
            <input [matDatepicker]="to" class="form-control" formControlName="invoiceDate" />
            <mat-datepicker-toggle matSuffix [for]="to">
              <img
                class="calendar"
                alt="calendar"
                matDatepickerToggleIcon
                src="assets/images/calendar.svg" />
            </mat-datepicker-toggle>
            <mat-datepicker #to></mat-datepicker>
          </div>
        </div>
        <small
          class="text-danger"
          *ngIf="shipmentForm.get('invoiceDetails').get('invoiceDate').errors"
          >{{ 'shipment.invoice.dateLabel' | translate }}
        </small>
      </div>
      <div class="col-md-5 form-group">
        <label>{{ 'shipment.invoice.exportReason' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="invoiceExportReason" />
        <app-error-component
          [controlName]="
            shipmentForm.get('invoiceDetails').get('invoiceExportReason')
          "></app-error-component>
      </div>
      <div class="col-md-5 form-group">
        <label>{{ 'shipment.invoice.incoterm' | translate }}: </label>
        <select class="form-control" type="text" formControlName="invoiceIncoterm">
          <option
            class="option"
            *ngFor="let incoterm of incoterms | dataPropertyGetter"
            [value]="incoterm.key">
            {{ incoterm.key }} - {{ incoterm.value }}
          </option>
        </select>
        <app-error-component
          [controlName]="
            shipmentForm.get('invoiceDetails').get('invoiceIncoterm')
          "></app-error-component>
      </div>
      <div class="col-md-5 form-group">
        <label>{{ 'shipment.invoice.unitOfMeasurement' | translate }}: </label>
        <select class="form-control" type="text" formControlName="invoiceUnitOfMeasurement">
          <option class="option" *ngFor="let uom of uoms | dataPropertyGetter" [value]="uom.key">
            {{ uom.key }} - {{ uom.value }}
          </option>
        </select>

        <app-error-component
          [controlName]="
            shipmentForm.get('invoiceDetails').get('invoiceUnitOfMeasurement')
          "></app-error-component>
      </div>
      <div class="col-md-5 form-group">
        <label>{{ 'shipment.invoice.placeOfIncoterm' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="placeOfIncoterm" />
        <app-error-component
          [controlName]="
            shipmentForm.get('invoiceDetails').get('placeOfIncoterm')
          "></app-error-component>
      </div>
      <div class="col-md-5 form-group">
        <label>{{ 'shipment.invoice.noOfLineItem' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="number"
          formControlName="noOfLineItem" />
        <app-error-component
          [controlName]="
            shipmentForm.get('invoiceDetails').get('noOfLineItem')
          "></app-error-component>
      </div>
    </div>
  </div>
</div>
